import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15 15",
	style: { enableBackground: "new 0 0 15 15" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M13.5,1.5l-12,12"
	}), /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M1.5,1.5l12,12"
	})] })]
});
export { SvgClose as ReactComponent };
